import React, {useState} from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import TitleSection from "../title-section";

import "./videoBanner.scss"
import "../number-steps/numberSteps.scss"

const VideoBanner = (props : ReferenciaContenido) => {
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
    return (
        <>
            <section className="o-video-banner">
                <img 
                    className="o-video-banner__img"
                    src={`https://img.youtube.com/vi/${props.redireccionBoton.split('/')[4]}/maxresdefault.jpg`} 
                    alt="Miniatura del Video de YouTube"
                />
                <div className="o-video-banner__text-container">
                    <TitleSection title={props.tituloGeneral} />
                    {documentToReactComponents(props.descripcion.json)}
                    <button
                        className="o-video-banner__button"
                        onClick={() => setIsOpenModal(true)}
                    >
                        {props.tituloBoton}
                    </button>
                </div>
            </section>
            {isOpenModal && (
                <div className="m-number-steps__modal">
                    <span className="icon-close" onClick={() => setIsOpenModal(false)}></span>
                    <div className="m-number-steps__modal-content">
                        <iframe
                            src={props.redireccionBoton}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
                        </iframe>
                    </div>
                </div>
            )}
        </>
    );
};

export default VideoBanner;